import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const editarMotivoDerivacion = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'PUT', url: `${ENTITY_URL.MOTIVO_DERIVACION.UPDATE}${params.idNitro4}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default editarMotivoDerivacion;